module.exports = __webpack_public_path__ + "static/media/monopoly-title.5d207365.png";